/* CreateOsPlanRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const InputTextControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputText;
const _ = require("lodash");

class CreateOsPlanRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("create-os-plan-gl");
        this._rootElem.component = this._model;

        this._nameField = new InputTextControl({
            darkTheme: true,
            placeholder: "Enter OS Plan Name",
        });
        this._confirmButton = new ButtonControl({
            label: "Create",
            darkTheme: true,
            disabled: true,
        });
        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true,
        });
        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model.titleText;

        this._buttonContainer = document.createElement("button-container");

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._confirmButton.on(
            "UserClick",
            (this._onConfirmButtonClick = this._onConfirmButtonClick.bind(this))
        );
        this._cancelButton.on(
            "UserClick",
            (this._onCancelButtonClick = this._onCancelButtonClick.bind(this))
        );
        this._nameField.on(
            "UserKeyDown",
            (this._checkForImpliedConfirm = this._checkForImpliedConfirm.bind(this))
        );
        this._nameField.on("UserValue", (this.checkValue = this.checkValue.bind(this)));
    }
    _unregisterListeners() {
        this._confirmButton.removeAllListeners("UserClick");
        this._cancelButton.removeAllListeners("UserClick");
        this._nameField.removeAllListeners("UserKeyDown");
        this._nameField.removeAllListeners("UserValue");
    }
    _onCancelButtonClick() {
        this._model.cancelPlan();
    }
    _onConfirmButtonClick() {
        this._callCreatePlan();
    }
    _checkForImpliedConfirm(event) {
        if (event.keyCode === 13) {
            if (!_.isEmpty(this._nameField.getValue())) {
                this._callCreatePlan();
            }
        }
    }
    checkValue(value) {
        this._confirmButton.disabled = _.isEmpty(value) || value.trim().length === 0;
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        let promArr = [
            this._nameField.shutdown(),
            this._confirmButton.shutdown(),
            this._cancelButton.shutdown(),
        ];

        return Promise.all(promArr).then(
            () => {
                this._nameField = undefined;
                this._confirmButton = undefined;
                this._cancelButton = undefined;
                this._buttonContainer.remove();
                this._buttonContainer = undefined;
                this._titleComponent.remove();
                this._titleComponent = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this._model.logger.warn(err, "CreateOsPlanRenderer.shutdown() error");
            }
        );
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titleComponent);
                this._rootElem.appendChild(this._nameField.renderer.rootElement);
                this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._confirmButton.renderer.rootElement);
                this._rootElem.appendChild(this._buttonContainer);
                setTimeout(() => {
                    this._nameField.focus();
                });
            }
            resolve();
        });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    //TODO Private Render Methods here
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _callCreatePlan() {
        this._model.createPlan(this._nameField.getValue());
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = CreateOsPlanRenderer;
